import Logo from '../../../assets/FooterLogo.svg'
import { useState,useEffect } from 'react'

export default function FooterLogo() {
    const [isMobile, setIsMobile] = useState(false)
    //choose the screen size
        const handleResize = () => {
        if (window.innerWidth < 720) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
        }

        // create an event listener
        useEffect(() => {
        window.addEventListener("resize", handleResize)
    },[])

    return   <img style={{display:isMobile ? 'none': 'block'}} width='206px' height='56px' src={Logo} alt='Logo' />
}